import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const FrontendHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLoginPage = location.pathname === "/";
  const [showLogout, setShowLogout] = useState(false);

  const token = localStorage.getItem("token");
  const userName = token ? jwtDecode(token)?.name : "";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <header
      className="shadow-sm sticky-top border-bottom"
      style={{
        backgroundColor: "#9642bc",
        minHeight: "clamp(100px, 15vh, 160px)",
        display: "flex",
        alignItems: "center",
        padding: "10px 0",
      }}
    >
      <div className="container-fluid px-2 px-md-4">
        <div className="row align-items-center g-0">
          {/* LEFT LOGO */}
          <div className="col-2 d-flex align-items-center justify-content-start py-2">
            <img
              src="/img/logo.png"
              alt="University Logo"
              style={{ maxHeight: "clamp(55px, 9vw, 100px)", width: "auto" }}
            />
          </div>

          {/* CENTER CONTENT */}
          <div className="col-8 text-center px-1">
            <div className="text-white d-flex flex-column gap-0">
              <h5
                className="fw-bold mb-0"
                style={{ fontSize: "clamp(0.65rem, 1.8vw, 1.2rem)" }}
              >
                DEPARTMENT OF DISTANCE AND CONTINUING EDUCATION
              </h5>
              <h5
                className="fw-bold mb-0"
                style={{ fontSize: "clamp(0.6rem, 1.8vw, 1.2rem)" }}
              >
                SCHOOL OF OPEN LEARNING (SOL)
              </h5>
              <h5
                className="fw-bold mb-0"
                style={{ fontSize: "clamp(0.6rem, 1.8vw, 1.1rem)" }}
              >
                CAMPUS OF OPEN LEARNING (COL)
              </h5>
              <h5
                className="fw-bold mb-0 mt-1"
                style={{ fontSize: "clamp(0.8rem, 2.2vw, 1.4rem)" }}
              >
                UNIVERSITY OF DELHI
              </h5>
            </div>
          </div>

          {isLoginPage && (
            <div className="col-2 d-flex align-items-center justify-content-end py-2">
              <img
                src="/img/du_logo.png"
                alt="University Logo"
                style={{ maxHeight: "clamp(55px, 9vw, 100px)", width: "auto" }}
              />
            </div>
          )}

          {/* RIGHT SECTION: LOGO (Print) or USER (Web) */}
          <div className="col-2 d-flex justify-content-end align-items-center">
            {/* 1. This Logo ONLY shows when printing */}
            <img
              src="/img/du_logo.png"
              alt="University Logo"
              className="d-none d-print-block"
              style={{ maxHeight: "clamp(55px, 9vw, 100px)", width: "auto" }}
            />

            {/* 2. This User Section ONLY shows on the screen */}
            {!isLoginPage && userName && (
              <div className="position-relative d-print-none">
                <div
                  className="text-white fw-bold d-flex flex-column align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowLogout((prev) => !prev)}
                >
                  <span style={{ fontSize: "1.5rem" }}>👤</span>

                  <span
                    style={{
                      fontSize: "clamp(0.6rem, 1vw, 0.8rem)",
                      textAlign: "center",
                      lineHeight: "1.1",
                      maxWidth: "100px", // Prevents the name from pushing the layout apart
                      wordWrap: "break-word",
                    }}
                  >
                    <h6>{userName}</h6>
                  </span>
                </div>

                {showLogout && (
                  <div
                    className="position-absolute bg-danger shadow rounded mt-2 p-2"
                    style={{ right: 0, zIndex: 1050, minWidth: "100px" }}
                  >
                    <button
                      className="btn btn-sm text-white fw-bold w-100 bg-danger"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default FrontendHeader;
